<script lang="ts">
	import { Router } from 'svelte-routing';
	import { onMount } from 'svelte';
	import { fetchUrl, cssToHead } from './share/utils';
	import { pages, redirectToHome, topNavigationVisible, topNavigationWidth } from './share/stores';

	import BreadCrumb from './partials/BreadCrumb.svelte';
	import Loading from './components/Loading.svelte';
	import TopNavigation from './partials/TopNavigation.svelte';
	import Stage from './partials/Stage.svelte';
	import LeftNavigationMobile from './fetch/LeftNavigationMobile.svelte';
	import LeftNavigation from './fetch/LeftNavigation.svelte';
	import CookieAlert from './partials/CookieAlert.svelte';

	let firstPageLoaded = false;

	function checkIfRedirectNeeded() {
		pages.subscribe(_pages => {
			_pages.map((_page, i) => {
				// pages-Array is initialized as [{"id":0,"path":"/","scrollTop":0}]
				// when visiting with e.g. "/qr" this will be appended but should not be there
				const redirectHome = redirectToHome.find(redirectRoute => redirectRoute.path === _page.path);
				if(!redirectHome) {
					return;
				}
				// instead of reloading the page (from "/qr" to "/"), splicing the array will keep the history clean
				// so when going e.g. "/qr" -> "/portfolio" -> "/agentur/kontakt" and then using
				// the pages builtin "back"-button, you'll end up at "/qr" instead of "/"
				_pages.splice(i, 1);
			})
			return _pages;
		})
	}

	onMount(() => {
		checkIfRedirectNeeded();

		cssToHead('/build/bundle.css');
		cssToHead('/generalCustomCss.css');

		// avoids initial menu popout:
		window.addEventListener('animatedPagesDone', () => firstPageLoaded = true);
	})
</script>

{#await fetchUrl('/') && fetchUrl('/navigation')}
	<Loading/>
{:then data}

	<Router>
		<TopNavigation/>
		<BreadCrumb/>
		<div class="content"
			 class:animate_transform={firstPageLoaded}
			 style="transform: translateX(-{$topNavigationVisible ? 0 : $topNavigationWidth}px)">
			<LeftNavigationMobile/>
			<LeftNavigation/>
			<Stage/>
		</div>
		<CookieAlert/>
	</Router>

{:catch error}
	<p>An error occurred!</p>
{/await}

<style lang="scss">
	@import "./style/global";

	div {
		flex-grow: 1;
		width: 100vw;
		position: relative;
		display: grid;
		grid-template-columns: min-content 100vw;

		&.animate_transform {
			transition: transform .2s ease-in-out;
		}

		@include for-tablet-landscape-up {
			grid-template-columns: max-content 100vw;
		}
	}
</style>
